module.exports = __webpack_public_path__ + "static/img/login-top.4e9df56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-top.png
// module id = 1UaN
// module chunks = 1